(() => {
  const norm = (s) =>
    (s || "")
      .toString()
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ")
      .replace(/[_-]+/g, " ");

  const getPicker = () => document.querySelector("hdt-variant-picker");
  const getColorInput = (picker) =>
    picker?.querySelector('fieldset.is-style-color input[is-value][type="hidden"]');

  const getMediaRoot = () => document.querySelector("hdt-product-media");
  const getTargets = (root) =>
    Array.from(root.querySelectorAll(".hdt-slider__slide, .hdt-product__media-item, .hdt-thumbnail__media"));

  const setHidden = (el, hidden) => {
    if (hidden) {
      el.hidden = true;
      el.setAttribute("hidden", "");
      el.style.display = "none";
    } else {
      el.hidden = false;
      el.removeAttribute("hidden");
      el.style.display = "";
    }
  };

  const apply = () => {
    const picker = getPicker();
    const colorInput = getColorInput(picker);
    const root = getMediaRoot();
    if (!picker || !colorInput || !root) return;

    const selected = norm(colorInput.value);
    if (!selected) return;

    // debug visible en console
    document.documentElement.dataset.mediaFilterColor = selected;
    document.documentElement.dataset.mediaFilterRan = String(Date.now());

    const els = getTargets(root);
    if (!els.length) return;

    els.forEach((el) => {
      const c = norm(el.dataset.color || "");
      const show = !c || c === selected;
      setHidden(el, !show);
    });

    document.documentElement.dataset.mediaFilterHiddenCount =
      String(root.querySelectorAll(".hdt-product__media-item[hidden]").length);

    window.dispatchEvent(new Event("resize"));
  };

  const schedule = () => {
    apply();
    setTimeout(apply, 120);
    setTimeout(apply, 300);
    setTimeout(apply, 700);
    setTimeout(apply, 1200);
  };

  const bind = () => {
    const picker = getPicker();
    const colorInput = getColorInput(picker);
    if (!picker || !colorInput) return;

    // ton picker dispatch maintenant bien change, donc ça doit suffire
    colorInput.addEventListener("change", schedule);

    // fallback click
    picker.addEventListener("click", (e) => {
      if (e.target.closest('button[role="option"]')) schedule();
    }, true);

    schedule();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", bind);
  } else {
    bind();
  }

  // Theme editor : quand Shopify re-render la section
  document.addEventListener("shopify:section:load", schedule);
  document.addEventListener("shopify:section:select", schedule);
})();
